import { PortableText } from '@portabletext/react'

export const SectionHeaderWithBody = ({ anchor = '', title, body }) => {
  return (
    <div className="px-20 py-40" id={anchor}>
      <div className="flex flex-col gap-32 rounded-10 bg-whiter p-20 text-darkGray shadow-md">
        <h2 className="text-48 uppercase leading-100 md:text-64">{title}</h2>
        <div className="text-16 leading-120 md:text-20">
          <PortableText value={body} />
        </div>
      </div>
    </div>
  )
}
